export default __webpack_public_path__ + "static/media/marcel-proust.4a5b6a06.jpg";